<template>
  <div class="home">
    <div class="top-white-box"></div>
    
    <div class="top-gray-box daily-deals-gray-box">
      <div><h1>Daily Deals</h1></div>
      <div class="daily-deals-date">{{ dailyDate }}</div>
    </div>

    <!--<GiveawayBox />-->
    <Deals :date="dailyDate" :showPrice="true" />

    <app-modal/>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Deals from '@/components/Deals.vue'
import settings from '@/settings'

export default defineComponent({
  name: 'home',
  components: {
    Deals
  },
  setup() {
    const route = useRoute()
    const dailyDate = ref<string>('')

    onMounted(() => {
      const date = new Date(route.params.date as string)
      dailyDate.value = date.toISOString().split('T')[0]
      document.title = `${settings.siteNameCaps} | ${dailyDate.value} Daily Deals`
    })

    const settingsComputed = computed(() => settings)

    return {
      dailyDate,
      settings: settingsComputed
    }
  }
})
</script>